import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

 const StyledBox = styled(Box)(({ theme }) => ({
 padding :theme.spacing(20, 0),
  [theme.breakpoints.down('lg')]: {
   padding :theme.spacing(18, 0),
  },
   [theme.breakpoints.down('lg')]: {
   padding :theme.spacing(12, 0),
  },
}));
export default StyledBox;